module.exports = __webpack_public_path__ + "static/media/om_eyeshape_monolid_lightbrown.65c86244.png";